import { render } from "./TicketDetails.vue?vue&type=template&id=22499b70&scoped=true"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"

import "./TicketDetails.vue?vue&type=style&index=0&id=22499b70&scoped=true&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22499b70"]])

export default __exports__